import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/agreementsAnalysisSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const FilterDropdown = ({ keyName, label, isMultiSelect = true }) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.agreementsAnalysis.filters[keyName]);
  const selectedOption = useSelector((state) => state.agreementsAnalysis.selectedFilters[keyName]);

  const onSelectChange = (data) => {
    dispatch(actionCreators.updateFilters({ [keyName]: data }));
  };

  return (
    <div className="select-box" style={{ width: "160px" }}>
      <p className="offers-title">{label}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        placeholder="Not selected"
        height={324}
        onSelectChange={onSelectChange}
        {...(isMultiSelect && {
          numberDisplayed: 0,
          includeSelectAll: true,
          enableOnly: true
        })}
      />
    </div>
  );
};

export default FilterDropdown;
